<router-outlet></router-outlet>

<app-statement-dialog></app-statement-dialog>

<ngx-loading
	[show]="this.layoutService.pageLoading$ | async"
	[config]="{
		backdropBorderRadius: '3px',
		fullScreenBackdrop: true,
		backdropBackgroundColour: '#F7F8F9',
		primaryColour: '#0D57A7',
		secondaryColour: '#ffdb7f',
		tertiaryColour: '#3e3a39'
	}"
	[template]="loadingTemplate"
></ngx-loading>
